import cc from "classcat"
import H2 from "components/atoms/H2"
import H5 from "components/atoms/H5"
import useTranslations from "hooks/useTranslations"
import LocalizedLink from "components/LocalizedLink"
import SectionContainer from "components/molecules/common/SectionContainer"

const SomeguideCard = ({ guide }) => {
  return (
    <li
      key={guide.data.guide_name.text}
      className="col-span-1 flex justify-center rounded-2xl bg-gray-50/70 hover:bg-gray-50/50"
    >
      <a href={`/some/${guide.data.guide_name.text}`}>
        <div className="space-y-4 px-8 py-8 ">
          <img className="mx-auto h-20 w-20" src={guide.data.logo.url} alt="" />
          <div className="space-y-2">
            <div className="space-y-1 text-lg font-medium leading-6">
              <h4>{guide.data.service_name.text}</h4>
            </div>
          </div>
        </div>
      </a>
    </li>
  )
}

const Item = ({ guide }) => {
  return (
    <LocalizedLink to={guide.slug}>
      <div className="flex h-full cursor-pointer flex-col space-y-2 rounded-xl pb-2 pt-6 hover:bg-zinc-100">
        <img
          className="mx-auto h-20 w-20 sm:h-16 sm:w-16 xl:h-20 xl:w-20"
          src={guide.data.logo.url}
          alt=""
        />
        <div className="mx-auto max-w-md">{guide.data.service_name.text}</div>
      </div>
    </LocalizedLink>
  )
}

const SomeguidesList = ({ items }) => {
  const { allSomeGuidesTitle, allSomeGuidesSubtitle } = useTranslations()
  return (
    <SectionContainer>
      <div className="relative mx-auto max-w-7xl space-y-16 px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
        <div className="space-y-12 text-center">
          <div className="mx-auto space-y-5 sm:space-y-4">
            <H2 textAlign="center" size="lg">
              {allSomeGuidesTitle}
            </H2>
            <H5 textAlign="center">{allSomeGuidesSubtitle}</H5>
          </div>
          <ul
            className={cc([
              "mx-auto mt-8 grid gap-y-8  md:divide-y-0 lg:mt-0",
              {
                "grid-cols-1": items.length === 1,
                "grid-cols-2 md:mx-40 md:grid-cols-2": items.length === 2,
                "grid-cols-2 md:mx-36 md:grid-cols-3": items.length === 3,
                "grid-cols-2 md:grid-cols-4": items.length === 4,
                "grid-cols-2 md:grid-cols-5": items.length >= 5,
              },
            ])}
          >
            {items.map((guide) => (
              <Item guide={guide} />
            ))}
          </ul>
        </div>
      </div>
    </SectionContainer>
  )
}
export default SomeguidesList
